import _ from 'lodash';

import { Types } from 'app/actions/company-admin/page-brackets-edit';
import utils from 'app/reducers/utils';

const initialState = {
  bracketId: null,
  loadPending: false,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.LOAD}_PENDING`]: (state, {bracketId}) => {
    return {...state,
      bracketId,
      loadPending: true,
    };
  },
  [`${Types.LOAD}_RESOLVED`]: (state, {bracketId}) => {
    if (bracketId !== state.bracketId) return state;
    return {...state,
      loadPending: false,
    };
  },

});

export default reducer;
